import { GalleryHero, GalleryGrid } from '@/components/sections/gallery'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const GalleryPage = () => {
  usePageTitle('Gallery')

  return (
    <>
      <GalleryHero />
      <GalleryGrid />
      <FinalCTA />
    </>
  )
}
